function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const compose = (validators)=>(value, allValues)=>{
        const result = validators.reduce((error, validator)=>error || (null == validator ? void 0 : validator(value, allValues)), void 0);
        return result;
    };
const composeWarnings = (validators)=>(value, allValues)=>_async_to_generator(function*() {
            const warnings = [];
            for (const validator of validators)if (validator) {
                const result = yield validator(value, allValues);
                if (result) warnings.push(result);
            }
            return warnings;
        })();
export { compose, composeWarnings };
